'use client';

import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useAuth } from 'react-oidc-context';

import { Add, Check, Close } from '@zoomit/icons';
import { Col, Flex, IconButton, Spacing } from '@zoomit/primitives';
import { Button, cssVar, Input, theme, Typography } from '@zoomit/zoomit-ds';

import { useAddBookmark } from '../../hooks/useBookmarksManagement';
import type { BookmarkAddFormType } from '../../types/articles';

const ArticleBookmarkAddForm = () => {
  const { isAuthenticated } = useAuth();
  const [showForm, setShowForm] = useState(false);
  const formMethods = useForm<BookmarkAddFormType>();
  const { handleSubmit, setValue, watch, register } = formMethods;
  const addBookmark = useAddBookmark();

  return (
    <FormProvider {...formMethods}>
      <form
        onSubmit={handleSubmit((data: BookmarkAddFormType) => {
          setValue('name', '');
          addBookmark.mutate(data);
          setShowForm(false);
        })}
        className="w-full"
      >
        <Flex justifyContent="space-between" alignItems="center">
          {!showForm && (
            <Flex justifyContent="flex-start">
              <Button
                size="fit"
                rightIcon={<Add size="md" className="!fill-success1" />}
                variant="text"
                onClick={() => {
                  setShowForm(true);
                }}
                className="!pr-0"
              >
                <Typography variant="h6" textColor={cssVar(theme.success1)}>
                  لیست جدید ایجاد کن
                </Typography>
              </Button>
            </Flex>
          )}
          {showForm && (
            <Flex className="w-full" alignItems="center" justifyContent="space-between">
              <Col md={11} size={9}>
                <Input {...register('name')} placeholder="نام لیست را وارد کنید" autoFocus />
              </Col>
              <Col md={1} size={3}>
                <Flex gap={Spacing.x3} justifyContent="flex-end">
                  <IconButton disabled={!isAuthenticated || watch('name')?.length < 1} type="submit">
                    <Check size="dl" fill={cssVar(theme.success1)} />
                  </IconButton>
                  <IconButton onClick={() => setShowForm(false)}>
                    <Close size="dl" fill={cssVar(theme.grey1)} />
                  </IconButton>
                </Flex>
              </Col>
            </Flex>
          )}
        </Flex>
      </form>
    </FormProvider>
  );
};

export default ArticleBookmarkAddForm;
